import axios from 'axios'
import {
  getStoredBackendVersion,
  setStoredBackendVersion,
  triggerHardReloadApplication
} from '../state/store'

const backendVersionHeaderName = 'x-app-companion-backend-version'
const backendVersionReloadTargetStorageKey = 'app-backend-reload-target-version'
const versionMismatchRetryMs = 5 * 60 * 1000 // Retry reload if version still mismatches after 5 minutes.
let isInitialized = false

const resolveBackendVersionFromHeaders = (headers) => {
  if (!headers || typeof headers !== 'object') {
    return undefined
  }

  return headers[backendVersionHeaderName] ?? headers[backendVersionHeaderName.toLowerCase()]
}

export const initializeBackendVersionSynchronization = () => {
  if (isInitialized) {
    return
  }

  isInitialized = true

  axios.interceptors.response.use(
    (response) => {
      const backendVersion = resolveBackendVersionFromHeaders(response?.headers)
      if (!backendVersion) {
        return response
      }

      const storedBackendVersion = getStoredBackendVersion()
      if (storedBackendVersion && storedBackendVersion !== backendVersion) {
        let shouldSkip = false
        try {
          const raw = localStorage.getItem(backendVersionReloadTargetStorageKey)
          if (raw) {
            const guard = JSON.parse(raw)
            if (guard?.version === backendVersion && Date.now() - (guard?.attemptedAt ?? 0) < versionMismatchRetryMs) {
              shouldSkip = true
            }
          }
        } catch (_) { /* ignore corrupt guard */ }

        if (shouldSkip) {
          setStoredBackendVersion(backendVersion)
          return response
        }

        localStorage.setItem(backendVersionReloadTargetStorageKey, JSON.stringify({ version: backendVersion, attemptedAt: Date.now() }))
        triggerHardReloadApplication().catch((error) => {
          console.error(error)
        })
        return response
      }

      localStorage.removeItem(backendVersionReloadTargetStorageKey)
      setStoredBackendVersion(backendVersion)
      return response
    },
    (error) => Promise.reject(error)
  )
}
